import React from 'react'
import FontAwesome from 'react-fontawesome'
import { useHistory } from 'react-router-dom'
import './itemList.scss'

const ItemList = ({ path, openNewTab, iconType, title, subtitle }) => {
  const history = useHistory()

  const goTo = () => {
    if (openNewTab) {
      window.open(path, '_blank')
    } else {
      history.push(path)
    }
  }

  return (
    <div className="configuration container d-flex" onClick={goTo}>
      {iconType && <span className={`d-flex align-items-center item-icon ${iconType}`} />}
      <div className={`col-11 ${iconType ? 'row pl-4 ' : ''}`}>
        <p className={`category-title ${iconType ? 'col-12 ' : ''} ${subtitle ? 'mt-3 mb-0' : 'mt-4 mb-4'}`}>{title}</p>
        {subtitle && <p className={`description-card ${iconType ? 'col-12' : ''}`}>{subtitle}</p>}
      </div>
      <FontAwesome className="col-1 d-flex align-items-center justify-content-center" name="chevron-right" />
    </div>
  )
}

export default ItemList
